module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.selfService.createTenant.logout":"Logout"}}')
  delete Component.options._Ctor
}
